import { ChangeDetectorRef, Component, ComponentRef, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject } from 'rxjs';
import { DataTableFilter } from '../DataTableFilter';
import { ActiveEventMessage, DataTableFilterMessageService } from '../data-table-filter-message-service';
import { BaseDataTableFilter } from './BaseDataTableFilter';

@Component({
  selector: 'app-data-table-filter',
  templateUrl: './data-table-filter.component.html',
  styleUrls: ['./data-table-filter.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    CommonModule, 
    MatButtonModule
  ]
})
export class DataTableFilterComponent implements OnInit {

  ARROW_DROP_DOWN = 'arrow_drop_down';
  ARROW_DROP_UP = 'arrow_drop_up';

  @Input() component?: string = '';
  @Input() filterDefinition!: DataTableFilter;
  @Input() disable!: BehaviorSubject<boolean>;

  @Output() filterClickedEvent: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('filter', { read: ViewContainerRef, static: false }) set content(filter: ViewContainerRef) {
    if(!filter) {
      return;
    }

    //This inserts the actual "body" of the filter component. 
    //Since the filter is conditionally shown (*ngIf="showFilterComponent") we have to create the component here only when the #filter ng-template is available on the DOM
    const component: ComponentRef<BaseDataTableFilter> = filter.createComponent(this.filterDefinition.component);
    component.instance.id = this.filterDefinition.id;
    component.changeDetectorRef.detectChanges();
  };

  dropDownIcon = this.ARROW_DROP_DOWN;
  showFilterComponent = false;
  hideClearButton = false;
  clickoutEnabled = true;
  isActive = false;

  constructor(
    private elementRef: ElementRef, 
    private messageService: DataTableFilterMessageService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.hideClearButton = this.filterDefinition.hideClearButton ? this.filterDefinition.hideClearButton : false;

    this.messageService.clickoutEnabledEvent.subscribe((enabled: boolean) => {
      this.clickoutEnabled = enabled;
      this.cdr.detectChanges();
    });

    this.messageService.activeEvent.subscribe((message: ActiveEventMessage) => {
      if (this.component === 'Organizations') {
        this.filterClickedEvent.emit(message);
      } else {
        if (this.filterDefinition.id === message.filterId) {
          this.isActive = message.active;
          this.cdr.detectChanges();
        }
      }
    });
  }

  onClickEvent(): void {
    if(!this.disable.value) {
      this.updateShowState(!this.showFilterComponent);
    }
  }

  onApplyClick(): void {
    if(!this.disable.value) {
      this.updateShowState(false);
      this.messageService.onApplyClicked(this.filterDefinition.id);
    }
  }

  onClearClick(): void {
    if(!this.disable.value) {
      this.updateShowState(false);
      this.messageService.onClearClicked(this.filterDefinition.id);
    }
  }
  
  @HostListener('document:click', ['$event'])
  clickout(event: any): void {
    if(!this.elementRef.nativeElement.contains(event.target) && this.clickoutEnabled) {
      this.updateShowState(false);
    }
  }

  updateShowState(show: boolean): void {
    this.showFilterComponent = show;
    this.dropDownIcon = this.showFilterComponent ? this.ARROW_DROP_UP : this.ARROW_DROP_DOWN;
  }
}